<script>
import Vue from 'vue'
import domToImage from 'dom-to-image'
import { Toast } from 'bxs-ui-vue'

import { normalizeKeys, insTypeOrders } from 'base/config'
import { tempToFill } from 'components/liability/common'
import { removeClass, getScreenSize, prefixStyle } from 'common/js/dom'
import {
  formatDisplayData,
  formatCalculateData,
  formatTenThousand
} from 'common/js/format'

import { baoeShowWords } from '../../common.js'
import { mergeImagesByCanvas } from '../../handler.js'
import HorizontalTable from './horizontalTable'
import VerticalTable from './verticalTable'
import FamilyTable from './familyTable'

Vue.use(Toast)
export default {
  components: {
    HorizontalTable,
    FamilyTable,
    VerticalTable
  },
  props: {
    resultData: {
      type: Object,
      default: () => ({})
    },
    scene: Number,
    vertical: Boolean,
    isShowBusinessCard: Boolean,
    cardImageData: String
  },
  data () {
    return {
      tableData: [],
      styleObject: {},
      cacheImageDataUrl: {}
    }
  },
  computed: {
    isShowInPc () {
      return [5, 6].includes(this.scene)
    },
    dataURLName () {
      return `${this.isShowBusinessCard ? 'card' : 'nocard'}`
    },
    currentComponent () {
      return [2, 4, 6].includes(this.scene) ? 'FamilyTable' : this.vertical ? 'VerticalTable' : 'HorizontalTable'
    }
  },
  watch: {
    resultData: {
      handler (value) {
        this.tableData = [2, 4, 6].includes(this.scene) ? this.formatFamilyData(value.members) : [this.formatPbData(value)]
      },
      immediate: true
    },
    isShowBusinessCard () {
      this.initTableStyle()
    }
  },
  mounted () {
    this.initTableStyle()
  },
  methods: {
    initTableStyle () {
      const self = this
      const refTable = self.$refs.planTable
      if (!refTable) {
        return
      }
      const size = getScreenSize()
      const viewProt = self.isShowInPc ? 0.96 : 0.8
      const viewSize = {
        width: size.width * viewProt,
        height: 400 * viewProt
      }
      self.$nextTick(() => {
        const imageTable = refTable.$el
        const imageTableParent = imageTable.parentElement
        const width = imageTable.offsetWidth
        const height = imageTable.offsetHeight
        const parentWidth = imageTableParent.offsetWidth
        const parentHeight = imageTableParent.offsetHeight
  
        let scale = width > height ? viewSize.width / width : viewSize.height / height
        self.styleObject = {
          [prefixStyle('transform')]: `translate(${(parentWidth - width * scale) / 2}px, ${(parentHeight - height * scale) / 2}px) scale(${scale})`,
          [prefixStyle('transformOrigin')]: 'left top'
        }
        if (self.isShowInPc) {
          scale = viewSize.width / width
          self.styleObject = {
            [prefixStyle('transform')]: `translate(${(parentWidth - width * scale) / 2}px, 20px) scale(${scale})`,
            [prefixStyle('transformOrigin')]: 'left top'
          }
          setTimeout(() => {
            imageTableParent.style.height = height * scale + 160 + 20 + 'px'
          }, 1000)
        }
      })
    },
    checkDataValidity (resultData, liabilities) {
      if (
        resultData &&
        Array.isArray(resultData.productGroupList) &&
        Array.isArray(resultData.productGroupList[0].prodOrderList) &&
        Array.isArray(liabilities)
      ) {
        return true
      }
      return false
    },
    // 格式化计划书数据
    formatPbData (preData) {
      // 获取人员数据seth
      function getAPersonData (planbookResult, key) {
        if (!key || !Array.isArray(planbookResult.personData.personOrderList)) {
          return {}
        }
        return planbookResult.personData.personOrderList.find(item => {
          return item.key === key
        })
      }
      // 获取保费总计
      function getTotalBaof (productList) {
        return productList.reduce((previous, current) => {
          previous += parseFloat(current.totalBaof)
          return previous
        }, 0)
      }
      // 获取保障责任(desc1)
      function getLiabilitiesComponents (liability, insuranceData) {
        if (!liability) return
        const productLiability = liability && liability.insuranceLiabilities
        const productId = liability && liability.productId
        if (!productLiability || !productId) return []
        function buildInsuranceInfo (insuranceLiability) {
          if (!Array.isArray(insuranceLiability.liabilities)) return
          return insuranceLiability.liabilities
            .map(item => {
              if (!item.description1) return
              const parsedDesc1Cfg = {
                productId,
                temp: item.description1,
                data: insuranceData
              }
              return {
                categoryId: item.categoryId,
                categoryName: item.categoryName,
                childTags: item.childTags,
                parsedDesc1: tempToFill(parsedDesc1Cfg, formatDisplayData)
              }
            })
            .filter(item => item)
        }
        return productLiability.map(item => {
          return buildInsuranceInfo(item)
        })
      }
      // 构建表格数据
      function buildTableInfo (productList, liabilities, insuranceData) {
        return productList.reduce((accumulate, current) => {
          const { companyName, titleName, totalBaof, mulInsOrderList } = current
          const main = mulInsOrderList[0]
          const index = liabilities && liabilities.findIndex(e => e.productId === current.key)
          const liab = index > 0 || index === 0 ? liabilities[index] : null
          let liability = []
          if (liab) {
            const descLiabilities = getLiabilitiesComponents(
              liab,
              insuranceData
            )
            liability = (descLiabilities || []).filter(e => !!e).reduce((prev, cur) => prev.concat(cur), [])
          }
          const item = {
            companyName,
            titleName,
            totalBaof,
            liability,
            baoeDp: formatTenThousand(baoeShowWords(main)),
            iDurationDesc: main.iDurationDesc,
            pPeriodDesc: main.pPeriodDesc
          }
          accumulate.push(item)
          return accumulate
        }, [])
      }

      const { resultData, liabilities, categorySortList } = preData
      if (!this.checkDataValidity(resultData, liabilities)) {
        return
      }
      const prodOrderList = resultData.productGroupList[0].prodOrderList
      const calData = formatCalculateData(resultData, normalizeKeys).calData

      const [insuredInfo, applicantInfo] = ['insuredInfo', 'applicantInfo'].map(
        key => {
          const item = getAPersonData(resultData, key)
          if (item) {
            item.sexDesc = item.sex === 2 ? '女' : '男'
          }
          return item
        }
      )

      const categorySort = Array.isArray(categorySortList)
        ? categorySortList
        : insTypeOrders[resultData.categorySort]

      return {
        insuredInfo,
        applicantInfo,
        categorySort,
        totalBaof: getTotalBaof(prodOrderList),
        tableList: buildTableInfo(prodOrderList, liabilities, calData)
      }
    },
    // 格式化家庭计划书数据
    formatFamilyData (memberList) {
      const vm = this
      function getMemberInfo (members, key) {
        return members.find(item => item.id === key)
      }
      function getMemberPlanbookData (planbookList, memberList) {
        if (!Array.isArray(planbookList)) return []
        return planbookList.reduce((acc, cur) => {
          const _memberInfo = getMemberInfo(
            memberList,
            cur.activeMemberId
          ) || {}
          const { name, sex, type } = _memberInfo || {}
          const planbookData = {
            name,
            sex,
            type,
            ...vm.formatPbData(cur)
          }
          return acc.concat(planbookData)
        }, [])
      }
      function getMemberTableLength (dataList) {
        return dataList.reduce((previous, current) => {
          previous += Array.isArray(current.tableList)
            ? current.tableList.length
            : 0
          return previous
        }, 0)
      }
      function getTotalBaof (dataList) {
        return dataList.reduce((previous, current) => {
          previous += parseFloat(current.totalBaof)
          return previous
        }, 0)
      }
      if (!Array.isArray(memberList)) {
        return
      }
      const normalizedData = memberList.reduce((accumulate, current, index) => {
        const list = getMemberPlanbookData(current.insurances, memberList)
        const memberData = {
          list,
          totalCount: 1,
          name: current.name,
          sex: current.sex,
          type: current.type
        }
        if (list.length) {
          memberData.totalCount = getMemberTableLength(list)
        }
        memberData.totalBaof = getTotalBaof(list)
        return accumulate.concat(memberData)
      }, [])
      return normalizedData
    },
    async generateImage (isShowLoading = true) {
      const { isShowBusinessCard, cardImageData, cacheImageDataUrl, dataURLName } = this
      if (!cacheImageDataUrl[dataURLName]) {
        if (isShowLoading) {
          appBridge.showLoading()
        }
        const dataURL = await this.getTableDataURL()
        cacheImageDataUrl[dataURLName] = await mergeImagesByCanvas([dataURL, isShowBusinessCard ? cardImageData : ''].filter(e => !!e))
        if (isShowLoading) {
          appBridge.hideLoading()
        }
      }
      return cacheImageDataUrl[dataURLName]
    },
    getTableDataURL () {
      const vm = this
      const node = this.$refs.planTable.$el
      const cloneNode = node.cloneNode(true)
      removeClass(cloneNode, 'image-table')
      cloneNode.setAttribute('style', '')
      const cardImageDom = cloneNode.querySelector('.card_image_wrap')
      if (cardImageDom) {
        cloneNode.removeChild(cardImageDom)
      }
      this.$refs.copyScene.appendChild(cloneNode)
      return domToImage
        .toPng(cloneNode)
        .then(dataURL => dataURL)
        .catch(error => {
          console.error('oops, something went wrong!', error)
          vm.$toast('暂不支持')
        })
    }
  }
}
</script>
<template>
  <div class="form-plan">
    <component
      :is="currentComponent"
      ref="planTable"
      class="image-table"
      :style="styleObject"
      :table-data="tableData"
      :is-show-business-card="isShowBusinessCard"
      :card-image-data="cardImageData"
      @view="$emit('previewAllImages')"
    />
    <div ref="copyScene" class="copy-scene" />
  </div>
</template>
<style scoped>
.form-plan {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.image-table {
  display: inline-block;
}

.copy-scene {
  overflow: hidden;
  width: 0px;
  height: 0px;
}
</style>
<style lang="postcss">
.table-layout {
  .description1 {
    > span {
      color: #ff5000;
      font-size: inherit;
    }
  }

  .table-bg {
    background-color: #f8f8f8;
  }
}
</style>
